import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import iView from "view-design";
import "view-design/dist/styles/iview.css";
import axios from 'axios';

var moment = require('moment');


Vue.prototype.$http = axios;
const token = sessionStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token
}
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Origin'] = "*"
Vue.prototype.$http.defaults.headers.common['Content-Type'] = 'application/json'
Vue.prototype.$http.defaults.headers.common['Accept'] = 'application/json, text/plain, */*'
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Methods'] = "GET, POST, PATCH, PUT, DELETE, OPTIONS"
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Headers'] = "Origin, X-Requested-With, Content-Type, Accept, X-Auth-Token, access-control-allow-origin, Authorization"
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Credentials'] = "true"

Vue.config.productionTip = false;
Vue.use(iView);

Vue.filter('timeFormat', function(tick) {
  return moment(tick).format("LTS");
});

Vue.filter('dateFormat', function(tick) {
  return moment(tick).format("L LTS");
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
